var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgNewForm(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 20,
    viewBox: "0 0 17 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.6667 8.75001V5.66667C14.6667 4.26654 14.6667 3.56647 14.3942 3.0317C14.1545 2.56129 13.7721 2.17884 13.3017 1.93916C12.7669 1.66667 12.0668 1.66667 10.6667 1.66667H5.33337C3.93324 1.66667 3.23318 1.66667 2.6984 1.93916C2.22799 2.17884 1.84554 2.56129 1.60586 3.0317C1.33337 3.56647 1.33337 4.26654 1.33337 5.66667V14.3333C1.33337 15.7335 1.33337 16.4335 1.60586 16.9683C1.84554 17.4387 2.22799 17.8212 2.6984 18.0609C3.23318 18.3333 3.93324 18.3333 5.33337 18.3333H8.00004M9.66671 9.16667H4.66671M6.33337 12.5H4.66671M11.3334 5.83334H4.66671M13 17.5V12.5M10.5 15H15.5",
    stroke: "white",
    strokeWidth: 1.66667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNewForm);
export default __webpack_public_path__ + "static/media/newForm.d3fb1b6847af88b6b264254438003167.svg";
export { ForwardRef as ReactComponent };